import {Box} from "@mui/material";
import { H4,H6 } from "../components/Typography";
import { FC } from "react";
// root component interface
interface CardProps {
  data?: any;
}

const BankCard: FC<CardProps> = ({ data }) => {

  return (
    <Box
      sx={{
        width: {
          md:"98%",
          xs:"92%"
        },
        background: "#F6F6F6",
        borderRadius: 2,
        p: {
          md:2,
          xs:1
        },
        flexDirection: "row",
        display: "flex",
        justifyContent: "space-between",
        mt: 2,
      }}
    >
      <Box
        sx={{
          width: "100%",
          background: "#fff",
          borderRadius: 2,
          justifyContent: "space-between",
          display: "flex",
          flexDirection:{
            md:"row",
            xs:"column"
          },
        
        }}
      >
        {/* Allocation */}
        <Box
          sx={{
            justifyContent: "center",
            alignItems:{
              md:'center',
              xs:'flex-start'
            },
            display: "flex",
            flexDirection: "column",
            width:{
              md:"25%",
              xs:"100%"
            },
            mt:{
              md:0,
              xs:1
            },
            ml:{
              md:0,
              xs:2
            },
           p:{
              md:2,
              xs:0
            },
          }}
        >
          <H4
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",

              color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
            }}
            fontWeight={"500"}
          >
           {data?.fullName}
          </H4>
          <H6
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              mt: 0.8,
              color: "#000000",
            }}
            fontWeight={"500"}
          >
           Account Holder
          </H6>
        </Box>
        <Box
          sx={{
            justifyContent: "center",
            alignItems:{
              md:'center',
              xs:'flex-start'
            },
            display: "flex",
            flexDirection: "column",
            width:{
              md:"25%",
              xs:"100%"
            },
            mt:{
              md:0,
              xs:1
            },
            ml:{
              md:0,
              xs:2
            },
          }}
        >
          <H4
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",

              color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
            }}
            fontWeight={"500"}
          >
           {data?.bankName}
          </H4>
          <H6
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              mt: 0.8,
              color: "#000000",
            }}
            fontWeight={"500"}
          >
           Bank Name
          </H6>
        </Box>
        {/* Gaurdaian Name */}
      
        <Box
          sx={{
            justifyContent: "center",
            alignItems:{
              md:'center',
              xs:'flex-start'
            },
            display: "flex",
            flexDirection: "column",
            width:{
              md:"25%",
              xs:"100%"
            },
            mt:{
              md:0,
              xs:1
            },
            ml:{
              md:0,
              xs:2
            },
          }}
        >
           <H4
              sx={{
                fontFamily: "'Poppins', sans-serif",
                textAlign: "center",

                color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
              }}
              fontWeight={"500"}
            >
                 {data?.accountNumber}
            </H4>
            <H6
              sx={{
                fontFamily: "'Poppins', sans-serif",
                textAlign: "center",
                mt: 0.8,
                color: "#000000",
              }}
              fontWeight={"500"}
            >
             Account Number
            </H6>
          </Box>
        
        {/* Gaurdaian Name */}
        <Box
          sx={{
            justifyContent: "center",
            alignItems:{
              md:'center',
              xs:'flex-start'
            },
            display: "flex",
            flexDirection: "column",
            width:{
              md:"25%",
              xs:"100%"
            },
            mt:{
              md:0,
              xs:1
            },
            ml:{
              md:0,
              xs:2
            },
            mb:{
              md:0,
              xs:1
            },
          }}
        >
     <H4
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",

              color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
            }}
            fontWeight={"500"}
          >
            {data?.ifscCode}
          </H4>
          <H6
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              mt: 0.8,
              color: "#000000",
            }}
            fontWeight={"500"}
          >
            IFSC Code
          </H6>
        </Box>
        {/* Gaurdaian Name */}
      </Box>
     
    </Box>
  );
};

export default BankCard;
